import useEventDetailsContext from './context';
import EventDetailsProvider from './provider';
export { EventDetailsProvider };
export default useEventDetailsContext;
